import { Subheader, TabPanel } from 'components';

import { AppBar, Container, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import BenchmarkDrillSubmissionPendingList from './BenchmarkDrillSubmissionsPendingList';
import BenchmarkDrillSubmissionCompletedList from './BenchmarkDrillSubmissionsListCompleted';

const BenchmarkDrillSubmissionsList = () => {
	const [tabValue, setTabValue] = useState(0);

	const handleTabChange = (_, newValue) => {
		setTabValue(newValue);
	};

	return (
		<>
			<Subheader title="Benchmark Drill Submissions" buttons={[]} />

			<Container maxWidth="xl">
				<AppBar
					position="static"
					style={{ background: '#FFF', color: '#000' }}
				></AppBar>
				<Tabs
					value={tabValue}
					onChange={handleTabChange}
					aria-label="Feedback Tabs"
				>
					<Tab label="Pending" />
					<Tab label="Completed" />
				</Tabs>
			</Container>
			<Container maxWidth="xl" className="custom-Mul-Container">
				<>
					<TabPanel value={tabValue} index={0}>
						<BenchmarkDrillSubmissionPendingList
							title={'Pending'}
							status={'pending'}
						/>
					</TabPanel>
					<TabPanel value={tabValue} index={1}>
						<BenchmarkDrillSubmissionCompletedList
							title={'Completed'}
							status={'completed'}
						/>
					</TabPanel>
				</>
			</Container>
		</>
	);
};

export default BenchmarkDrillSubmissionsList;
